module.exports = __webpack_public_path__ + "static/media/binTrans.4ad7beb3.png";